import $ from "jquery";
import plugin from "@core/plugins/lib";

const ELEMENT_SELECTOR = '[data-pop-window]';
const PLUGIN_NAME = 'PopWindow';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "pop-window" */ "./pop-window"
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/pop-window/plugin--split.js